<template>
  <section
    class="journey-builder"
    v-if="
      userTypesOptions.length == 0 && currentRoute == addJourneyFlow && !loading
    "
  >
    <PageHeader
      title="Journey Flow"
      className="d-flex align-items-center justify-content-between mb-2"
    >
      <div class="page-title-right mb-2 d-flex">
        <router-link to="/add-user-type">
          <b-button
            pill
            class="d-flex align-items-center px-4"
            variant="primary"
            size="md"
          >
            <i class="bx bx bx-plus font-size-18 mr-2"></i>
            <span role="link">
              {{ $t("journeyBuilder.flow.createUserType") }}
            </span>
          </b-button>
        </router-link>
        <router-link to="/journeys">
          <b-button
            pill
            class="d-flex align-items-center px-4 mx-3"
            variant="outline-primary"
            size="md"
          >
            <i class="bx bx bx bx-right-arrow-alt font-size-18 mr-2"></i>
            <span role="link">
              {{ $t("journeyBuilder.flow.journeysList") }}
            </span>
          </b-button>
        </router-link>
      </div>
    </PageHeader>
    <h4 class="mt-5 text-muted">
      {{
        $t("journeyBuilder.flow.thereIsNoUserTypesToAddNewFlowToThisJourney")
      }}
    </h4>
  </section>
  <section v-else class="journey-builder">
    <!-- selected journey wrapper  -->
    <div class="mb-3 d-flex justify-content-between">
      <div class="selected-journey journey-wrapper d-flex align-items-center">
        <label for="journey" class="mb-0">{{ $t("common.journey") }}: </label>
        <p class="text-muted mb-0 ml-2">
          {{ journeyName }}
        </p>
      </div>
      <router-link to="/add-journey" custom v-slot="{ navigate }">
        <b-button
          @click="navigate"
          pill
          class="d-flex align-items-center px-4"
          variant="outline-primary"
          size="sm"
        >
          <i class="bx bx-plus font-size-18 mr-2"></i>
          {{ $t("journeyBuilder.flow.addNewJourney") }}
        </b-button>
      </router-link>
    </div>
    <!-- journey builder wrapper  -->
    <div class="journey-builder d-flex">
      <div class="journey-inputs-wrapper">
        <!-- journey flow wrapper  -->
        <div class="form-elements-wrapper mb-3">
          <h5 class="text-muted mt-4 mb-3">
            {{
              $route.name == "updateFlow"
                ? $t("journeyBuilder.flow.updateJourneyFlow")
                : $t("journeyBuilder.flow.createJourneyFlow")
            }}
          </h5>
          <label for="flow_name" class="mb-1">{{
            $t("journeyBuilder.flow.flowName")
          }}</label>
          <b-form-input
            id="flow_name"
            class="mb-3"
            :placeholder="$t('journeyBuilder.flow.flowName')"
            v-model="name"
          ></b-form-input>
          <label for="flow_description" class="mb-1">{{
            $t("journeyBuilder.flow.flowDescription")
          }}</label>
          <b-form-textarea
            id="flow_description"
            v-model="description"
            class="form-control"
            rows="3"
            :placeholder="$t('journeyBuilder.flow.flowDescription')"
            no-resize
          ></b-form-textarea>
        </div>
        <div class="settings-wrapper mb-5">
          <!-- user types -->
          <div class="title-wrapper d-flex align-items-center mb-1">
            <label for="user_type" class="mb-0"
              >{{ $t("journeyBuilder.flow.userType") }}
            </label>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <multiselect
              id="user_type"
              v-model="userType"
              label="name"
              :options="userTypesOptions"
              :placeholder="$t('journeyBuilder.flow.selectUserType')"
              trackBy="id"
              :show-labels="false"
              :hideSelected="false"
              multiple
              @select="onSelectUserType"
              @input="
                checkNodeType(userTypeText)
                  ? editNode(userTypeText, userType)
                  : addNode(userTypeText, userType, 0, 100)
              "
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span
                    v-if="props.option.parent_id == null"
                    class="option__name font-weight-bold"
                    >{{ props.option.name }}</span
                  >
                  <span
                    v-else
                    class="option__usertype__child font-weight-bold ml-2"
                  >
                    - {{ props.option.name }}</span
                  >
                </div>
              </template>

              <template slot="selection" slot-scope="{ values }">
                <span
                  v-for="(selected, indx) in values"
                  :key="indx"
                  class="multiselect__tag"
                  :class="{ 'disabled-tags': selected.$isDisabled }"
                >
                  <span>{{ selected.name }}</span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    class="multiselect__tag-icon"
                    @click="
                      removeUserTypeHandler(selected.id);
                      onRemoveUserType(selected);
                    "
                  ></i>
                </span>
              </template>             
              <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
              <span slot="noOptions">{{$t('common.emptList')}}</span>
            </multiselect>
          </div>
          <p
            class="h5 my-2"
            style="color: DODGERBLUE; font-size: 14px"
            v-if="showUserTypeUnpermittedMessage"
          >
            <b-icon icon="info-circle"></b-icon>
            {{ unpermittedUserTypeMessage }}
          </p>
          <p
            class="h5 mb-2"
            style="color: DODGERBLUE; font-size: 14px"
            v-if="!touch_mode && registerationNotRequiredCount > 1"
          >
            <b-icon icon="info-circle"></b-icon>
            {{
              $t(
                "journeyBuilder.flow.onlyOneRegistrationNotRequiredUserypeMessage"
              )
            }}
          </p>

          <!-- input -->
          <div class="title-wrapper d-flex align-items-center mb-1">
            <label for="input" class="mb-0">{{
              $t("journeyBuilder.flow.input")
            }}</label>
            <button
              v-if="isRemoteSignInSelected"
              :disabled="disableJourneyInputs"
              class="bx bx-cog ml-1 settings-icon"
              @click="$bvModal.show('inputSettings')"
            />
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <multiselect
              id="input"
              v-model="input"
              label="label"
              :options="inputTypes"
              :placeholder="$t('journeyBuilder.flow.selectInput')"
              trackBy="name"
              :show-labels="false"
              :hideSelected="true"
              @input="
                checkNodeType(inputText)
                  ? editNode(inputText, input)
                  : addNode(inputText, input, 120, 100),
                  setInputNote()
              "
              multiple
              :disabled="!userType || disableJourneyInputs"
            >
              <template slot="selection" slot-scope="{ values }">
                <span
                  v-for="(selected, indx) in values"
                  :key="indx"
                  class="multiselect__tag"
                  :class="{ 'disabled-tags': selected.$isDisabled }"
                >
                  <span>{{ selected.label }}</span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    class="multiselect__tag-icon"
                    @click="removeInputHandler(selected.id)"
                  ></i>
                </span>
              </template>
            <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
            <span slot="noOptions">{{$t('common.emptList')}}</span>
            </multiselect>
          </div>
          <b-modal
            id="inputSettings"
            scrollable
            hide-footer
            hide-header
            size="lg"
            no-close-on-esc
            no-close-on-backdrop
          >
            <Input
              :settings="remoteSettings"
              @updateInputGeo="updateInputGeo"
            />
          </b-modal>
          <p
            class="h5 my-2"
            style="color: DODGERBLUE; font-size: 14px"
            v-if="showInputNoteForSingleFlow"
          >
            <b-icon icon="info-circle"></b-icon>
            {{ inputNoteForSingleFlow }}
          </p>
          <p
            class="h5 mb-2"
            style="color: DODGERBLUE; font-size: 14px"
            v-if="
              selected_register_not_required && isFaceRecognition && touch_mode
            "
          >
            <b-icon icon="info-circle"></b-icon>
            {{
              $t(
                "journeyBuilder.flow.faceRecognitionNotWorkUndefinedUsersMessage"
              )
            }}
          </p>

          <p
            class="h5 mb-2"
            style="color: DODGERBLUE; font-size: 14px"
            v-if="inputGeofenceSelected"
          >
            <b-icon icon="info-circle"></b-icon>
            <template v-if="!!inputGeofencingApplicableUserTypes.length">
              {{ $t("journeyBuilder.flow.theMobileAppSiteGeofenceInput") }}
              {{ formattedGeofencingUserTypes }}
              {{
                this.getLanguage == "en" ? $t("journeyBuilder.flow.users") : "."
              }}
            </template>
            <template v-else>
              {{
                $t(
                  "journeyBuilder.flow.mobileAppSiteGeofenceInputCantUsedSelectedUserTypes"
                )
              }}
            </template>
          </p>

          <p
            class="h5 mb-2"
            style="color: DODGERBLUE; font-size: 14px"
            v-if="inputGeofenceSelectedAndDisabled"
          >
            <b-icon icon="info-circle"></b-icon>

            {{
              $t(
                "journeyBuilder.flow.removingMobileAppAiteGeofenceOptionIsNotAllowedSignIn"
              )
            }}
          </p>

          <!-- checks -->
          <div class="title-wrapper d-flex align-items-center mb-1">
            <label for="check" class="mb-0">{{
              $t("journeyBuilder.flow.checks")
            }}</label>
            <button
              v-if="checkSetting"
              :disabled="disableJourneyInputs"
              class="bx bx-cog ml-1 settings-icon"
              @click="$bvModal.show('flowChecks')"
            />
            <b-modal
              id="flowChecks"
              :title="this.$t('journeyBuilder.flow.checkSettings')"
              no-close-on-esc
              no-close-on-backdrop
              hide-footer
              scrollable
              size="md"
            >
              <FlowChecks
                :checksSetting="checksSetting"
                @updateFlowChecks="updateFlowChecks"
              />
            </b-modal>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <multiselect
              id="check"
              v-model="check"
              :options="checksOptions"
              :placeholder="$t('journeyBuilder.flow.selectCheck')"
              :show-labels="false"
              :hideSelected="true"
              @input="
                checkNodeType(checksText)
                  ? editNode(checksText, check)
                  : addNode(checksText, check, 240, 100)
              "
              @remove="resetChecksSettings"
              multiple
              trackBy="name"
              label="label"
              :disabled="!userType || disableJourneyInputs"
              >
            <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
            <span slot="noOptions">{{$t('common.emptList')}}</span>
            </multiselect>
          </div>
          <!-- compliance -->
          <div class="title-wrapper d-flex align-items-center mb-1">
            <label for="compliance" class="mb-0">{{
              $t("common.compliance")
            }}</label>
            <button
              v-if="compliance && compliance.length"
              :disabled="disableJourneyInputs"
              class="bx bx-cog ml-1 settings-icon"
              v-b-modal="'complianceSettings'"
            />
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <multiselect
              id="compliance"
              v-model="compliance"
              :options="compliancesOptions"
              :placeholder="$t('journeyBuilder.flow.selectCompliance')"
              :show-labels="false"
              :hideSelected="true"
              trackBy="name"
              label="name"
              multiple
              :disabled="!userType || disableJourneyInputs"
              @select="updateComplianceMetadata"
              @remove="removeCompliance"
              @input="
                checkNodeType(complianceText)
                  ? editNode(complianceText, compliance)
                  : addNode(complianceText, compliance, 360, 100)
              "
           >
            <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
            <span slot="noOptions">{{$t('common.emptList')}}</span>
            </multiselect>
          </div>
          <b-modal
            id="complianceSettings"
            hide-footer
            hide-header
            title="Compliance Settings"
            size="md"
            no-close-on-esc
            no-close-on-backdrop
            scrollable
          >
            <ComplianceSettingsForm
              :compliances="onlineComplianceSettings"
              @complianceSettingsCanceled="onComplianceSettingsCanceled"
            />
          </b-modal>

          <!-- Section -->
          <div class="title-wrapper d-flex align-items-center mb-1">
            <label for="section" class="mb-0">{{
              $t("journeyBuilder.flow.section")
            }}</label>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <multiselect
              id="section"
              v-model="section"
              :options="sectionOptions"
              :placeholder="$t('journeyBuilder.flow.selectSection')"
              :show-labels="false"
              :hideSelected="true"
              trackBy="name"
              label="name"
              multiple
              :disabled="!userType || disableJourneyInputs || !applySection"
              @remove="removeSection"
              @input="
                checkNodeType(sectionText)
                  ? editNode(sectionText, section)
                  : addNode(sectionText, section, 480, 100)
              "
            >
            <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
            <span slot="noOptions">{{$t('common.emptList')}}</span>
            </multiselect>
          </div>
          <p
            class="h5 mb-2 vp-width-300"
            style="color: DODGERBLUE; font-size: 14px"
            v-if="!applySection"
          >
            <b-icon icon="info-circle"></b-icon>

            {{ sectionNote }}
            <span class="mail">cs@lamasatech.com.</span>
          </p>

          <!-- start::Host -->
          <template v-if="touch_mode">
            <div class="title-wrapper d-flex align-items-center mb-1">
              <label for="host" class="mb-0">{{
                $t("journeyBuilder.flow.host")
              }}</label>
              <button
                v-if="settings.host && settings.host.length"
                :disabled="disableJourneyInputs"
                class="bx bx-cog ml-1 settings-icon"
                @click="$bvModal.show('hostSettings')"
              />
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <multiselect
                id="host"
                v-model="settings.host"
                :options="hostOptions"
                :placeholder="$t('journeyBuilder.flow.selectHost')"
                :show-labels="false"
                :hideSelected="false"
                :multiple="true"
                label="name"
                trackBy="id"
                :disabled="disableJourneyInputs"
                @input="
                  checkNodeType(hostText)
                    ? editNode(hostText, settings.host)
                    : addNode(hostText, settings.host, 600, 100)
                "
              >
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span
                      v-if="props.option.parent_id == null"
                      class="option__name font-weight-bold"
                      >{{ props.option.name }}</span
                    >
                    <span
                      v-else
                      class="option__usertype__child font-weight-bold ml-2"
                    >
                      - {{ props.option.name }}</span
                    >
                  </div>
                </template>

                <template slot="selection" slot-scope="{ values }">
                  <span
                    v-for="(selected, indx) in values"
                    :key="indx"
                    class="multiselect__tag"
                    :class="{ 'disabled-tags': selected.$isDisabled }"
                  >
                    <span>{{ selected.name }}</span>
                    <i
                      aria-hidden="true"
                      tabindex="1"
                      class="multiselect__tag-icon"
                      @click="removeHostHandler(selected.id)"
                    ></i>
                  </span>
                </template>
                
                <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
                <span slot="noOptions">{{$t('common.emptList')}}</span>
              </multiselect>
            </div>
            <p
              class="h5 my-2"
              style="color: DODGERBLUE; font-size: 14px"
              v-if="showHostsUnpermittedUserTypeMessage"
            >
              <b-icon icon="info-circle"></b-icon>
              {{ unpermittedUserTypeMessage }}
            </p>
            <p
              class="h5 my-2"
              style="color: DODGERBLUE; font-size: 14px"
              v-if="hostNoteMessage"
            >
              <b-icon icon="info-circle"></b-icon> {{ hostNoteMessage }}
            </p>
            <b-modal
              id="hostSettings"
              scrollable
              hide-footer
              hide-header
              size="md"
              no-close-on-esc
              no-close-on-backdrop
            >
              <Host
                :touch_mode="touch_mode"
                :settings="hostSetting"
                @updateHost="updateHost"
              />
            </b-modal>
          </template>
          <!-- end::Host -->

          <!-- start::Attendance Mode -->
          <template v-if="touch_mode && showAttendanceModes">
            <div class="title-wrapper d-flex align-items-center mb-1">
              <label for="attendanceMode" class="mb-0">{{
                $t("attendanceModes.attendanceMode")
              }}</label>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <multiselect
                id="attendanceMode"
                v-model="settings.attendance_mode"
                :options="attendanceModesOptions"
                :placeholder="$t('journeyBuilder.selectMode')"
                :show-labels="false"
                label="name"
                trackBy="id"
                :disabled="disableAttendanceMode || disableJourneyInputs"
                @input="changeAttendanceModeVal"
                @remove="attendanceModeDeselect"
              >
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__name font-weight-bold">{{
                      props.option.name
                    }}</span>
                  </div>
                </template>
                
                <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
                <span slot="noOptions">{{$t('common.emptList')}}</span>
            </multiselect>
            </div>
            <!-- Only show message if attendance mode is selected -->
            <p
              v-if="settings.attendance_mode"
              class="h5 my-2"
              style="color: DODGERBLUE; font-size: 14px"
            >
              <b-icon icon="info-circle"></b-icon> {{ attendanceModesMessage }}
            </p>

            <p
              v-if="disableAttendanceMode"
              class="h5 my-2"
              style="color: DODGERBLUE; font-size: 14px"
            >
              <b-icon icon="info-circle"></b-icon>
              {{ disabledAttendanceModeMessage }}
            </p>
          </template>
          <!-- end::Attendance Mode -->

          <!-- output -->
          <div class="title-wrapper d-flex align-items-center mb-1">
            <label for="output" class="mb-0">{{
              $t("journeyBuilder.flow.output")
            }}</label>
            <button
              v-if="isOutputSetting"
              :disabled="disableJourneyInputs"
              class="bx bx-cog ml-1 settings-icon"
              @click="$bvModal.show('output-modal')"
            ></button>
            <b-modal
              id="output-modal"
              :title="$t('journeyBuilder.outputSettings')"
              no-close-on-esc
              no-close-on-backdrop
              scrollable
              hide-footer
              hide-header
            >
              <Output
                :output="output"
                :isHostSelected="isHostSelected"
                :isTemerpatureCheckSelected="isTemerpatureCheckSelected"
                :isAttendanceModeSelected="isAttendanceModeSelected"
                @updateOutput="updateOutput"
                @removeOutput="removeOutput"
                @undoOutputChanges="undoOutputChanges"
              />
            </b-modal>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <multiselect
              id="output"
              v-model="output"
              :options="outputs"
              :placeholder="$t('journeyBuilder.flow.selectOutput')"
              :show-labels="false"
              :hideSelected="true"
              @input="
                checkNodeType(outputText)
                  ? editNode(outputText, output)
                  : addNode(outputText, output, 840, 100)
              "
              multiple
              trackBy="label"
              label="label"
              :disabled="!userType || disableJourneyInputs"
              @remove="deselectOutput"
              @select="onOutputSelect"
              >
            <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
            <span slot="noOptions">{{$t('common.emptList')}}</span>
            </multiselect>
          </div>
          <!-- notification -->
          <div class="title-wrapper d-flex align-items-center mb-1">
            <label for="notification" class="mb-0">{{
              $t("journeyBuilder.flow.notification")
            }}</label>
            <button
              v-if="notification && notification.length"
              :disabled="disableJourneyInputs"
              class="bx bx-cog ml-1 settings-icon"
              @click="$bvModal.show('notification-modal')"
            ></button>
            <b-modal
              title="Notification Settings"
              id="notification-modal"
              no-close-on-esc
              no-close-on-backdrop
              scrollable
              hide-footer
              hide-header
              size="lg"
            >
              <Notification
                :currentSelectedNotification="notification"
                :settings="notificationSetting"
                :dataModel="notificationSettingModel"
                :currentAttendanceMode="settings.attendance_mode"
                :isAttendanceModeDisabled="disableAttendanceMode"
                @updateNotification="updateNotification"
              />
            </b-modal>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <multiselect
              id="notification"
              v-model="notification"
              :options="notifications"
              :placeholder="$t('journeyBuilder.flow.selectNotification')"
              :show-labels="false"
              :hideSelected="true"
              @input="
                checkNodeType(notificationText)
                  ? editNode(notificationText, notification)
                  : addNode(notificationText, notification, 960, 100)
              "
              multiple
              trackBy="label"
              label="label"
              :disabled="!userType || disableJourneyInputs"
              >
            <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
            <span slot="noOptions">{{$t('common.emptList')}}</span>
            </multiselect>
          </div>
          <!-- feedback -->
          <div class="title-wrapper d-flex align-items-center mb-1">
            <label for="feedback" class="mb-0"
              >{{ $t("journeyBuilder.flow.feedback") }}
            </label>
            <button
              v-if="isFeedbackSetting"
              :disabled="disableJourneyInputs"
              class="bx bx-cog ml-1 settings-icon"
              @click="$bvModal.show('feedback-modal')"
            ></button>
            <b-modal
              id="feedback-modal"
              size="lg"
              no-close-on-esc
              no-close-on-backdrop
              scrollable
              hide-footer
              hide-header
            >
              <Feedback
                :settings="feedbackSetting"
                @updateFeedback="updateFeedback"
              />
            </b-modal>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <multiselect
              id="feedback"
              v-model="feedback"
              :options="feedbacks"
              :placeholder="$t('journeyBuilder.selectFeedback')"
              multiple
              trackBy="label"
              label="label"
              :show-labels="false"
              @input="
                checkNodeType(feedbackText)
                  ? editNode(feedbackText, feedback)
                  : addNode(feedbackText, feedback, 1080, 100)
              "
              :hideSelected="true"
              :disabled="!userType || disableJourneyInputs"
              >
            <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
            <span slot="noOptions">{{$t('common.emptList')}}</span>
            </multiselect>
          </div>
        </div>
      </div>
      <div id="flowchart" class="w-100">
        <div
          class="d-md-flex justify-content-between align-items-center digram-config p-2"
          style="border: 1px solid #f8f8fb"
        >
          <div class="d-flex align-items-center my-2">
            <label v-if="userType" class="mb-0" style="margin-inline-end: 5px;" for="scale">{{
              $t("journeyBuilder.flow.scale")
            }}</label>
            <b-form-input
              size="sm"
              v-if="userType"
              id="scale"
              type="number"
              min="0.1"
              step="0.1"
              v-model.number="scene.scale"
            />
          </div>
          <div>
            <button
              @click="onBuilderSubmit"
              :disabled="getLoading"
              pill
              class="submit-btn btn btn-primary px-4 no-wrap btn-sm"
              size="md"
            >
              <i
                v-if="getLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
              ></i>
              <span v-else>
                {{
                  currentRoute == "updateFlow"
                    ? $t("journeyBuilder.flow.updateJourneyBuilder")
                    : $t("journeyBuilder.flow.saveJourneyBuilder")
                }}
              </span>
            </button>
            <router-link to="/journeys" custom v-slot="{ navigate }">
              <button
                @click="navigate"
                class="btn btn-outline-primary px-3 cancel-btn btn-sm my-2"
              >
                {{ $t("common.cancel") }}
              </button>
            </router-link>
          </div>
        </div>
        <light-flowchart
          class="flowchart-wrapper"
          :scene.sync="scene"
          @nodeDelete="nodeDelete"
        />
      </div>
    </div>
    
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LightFlowchart from "vue-light-flowchart";
import Multiselect from "vue-multiselect";
import ComplianceSettingsForm from "./CompliancesSettings";
import PageHeader from "@/components/page-header";
import { sliceLongString } from "@/utils/mixins/sliceLongString";
import integtationService from "@/services/integration";
import journeyService from "@/services/journey";
import FlowChecks from "@/components/journeyBuilder/modals/FlowChecks.vue";
import Output from "@/components/journeyBuilder/modals/Output.vue";
import Notification from "@/components/journeyBuilder/modals/Notification.vue";
import Feedback from "@/components/journeyBuilder/modals/Feedback.vue";
import Host from "@/components/journeyBuilder/modals/Host.vue";
import Input from "@/components/journeyBuilder/modals/Input.vue";
import {
  cloneDeep,
  compact,
  differenceBy,
  isEqual,
  uniqBy,
  orderBy,
} from "lodash";

export default {
  title: "Journey Builder",
  name: "SubmitBuilder",
  mixins: [sliceLongString],
  components: {
    Multiselect,
    LightFlowchart,
    ComplianceSettingsForm,
    PageHeader,
    FlowChecks,
    Output,
    Notification,
    Feedback,
    Host,
    Input,
  },
  data() {
    return {
      userTypeSettingsOption: [
        { id: 1, text: this.$t("common.minutes") },
        { id: 2, text: this.$t("common.hours") },
        { id: 3, text: this.$t("common.days") },
      ],
      userTypeText : this.$t('common.userType'),
      checksText : this.$t('common.checks'),
      sectionText : this.$t('journeyBuilder.flow.section'),
      inputText : this.$t('journeyBuilder.flow.input'),
      complianceText : this.$t('common.compliance'),
      hostText : this.$t('journeyBuilder.flow.host'),
      notificationText : this.$t('common.notifications'),
      attendanceModeText:this.$t('attendanceModes.attendanceMode'),
      feedbackText: this.$t('common.feedback'),
      outputText: this.$t('common.output'),
      inputOnMount: [],
      inputGeofenceSelectedAndDisabled: false,
      inputGeofenceSelected: false,
      showGeoFencingNote: false,
      inputGeofencingApplicableUserTypes: [],
      formattedGeofencingUserTypes: "",
      hasSignedInUsers: false,
      inputTypes: [],
      check: null,
      section: null,
      checksOptions: [],
      compliancesOptions: [],
      sectionOptions: [],
      sectionObject: null,
      hostOptions: [],
      hostNoteMessage: null,
      hostSettingObject: {},
      attendanceModeObject: {},
      journeyFlowId: null,
      inputSettings: [],
      remoteSettings: {},
      checksSetting: {},
      // outputSetting: [],
      notificationSetting: [],
      notificationSettingModel: {
        send_to_email: {
          id: null,
          value: null,
          metadata: null,
          type: "string",
        },
        send_via_email: {
          id: null,
          value: null,
          metadata: null,
          type: "boolean",
        },
      },
      allNotificationSettings: {},
      allFeedbackSettings: [],
      hostSetting: {},
      feedbackSetting: null,
      onlineComplianceSettings: {},
      onlineComplianceAllowedUserTypes: [
        "REGISTRATION_ALLOWED",
        "PRE_REGISTERED_ONLY",
        "PRE_REGISTRATION_WITH_APPROVAL_REQUIRED",
      ],
      userTypesOptions: [],
      attendanceModesOptions: [],
      hostTypesOptions: [],
      notReqUserTypeExists: false,
      registerationNotRequiredCount: 0,
      regNotReqSelectedOnCurrentFlow: false,
      companyTemp: "",
      isWalkinUserType: false,
      isFaceRecognition: false,
      isRemoteSignInSelected: false,
      currentRoute: null,
      addFlowRoute: "addFlow",
      addJourneyFlow: "addJourneyFlow",
      updateFlowRoute: "updateFlow",
      journeyName: null,
      journeyId: null,
      name: null,
      description: null,
      scene: {
        centerX: 900,
        centerY: 100,
        scale: 0.9,
        nodes: [],
        links: [],
        orientation: "hor",
        canChangeNodes: true,
        canChangeLinks: false,
      },
      journeyFlowSelection: null,
      journey: null,
      journeyFlow: {},
      createdArr: [],
      checkLinks: [],
      userTypeArray: [],
      dataUserType: "",
      //setting
      modalTitle: null,
      checkSetting: false,
      isTemperature: false,
      isVaccine: false,
      isFeedbackSetting: false,
      isOutputSetting: false,
      outputExist: false,
      settings: {
        show_user_type: true,
        show_temperature: true,
        show_company_name: true,
        save_scan_image: true,
        show_photo: true,
        show_name: true,
        show_date_time: true,
        check_type: {
          id: 0,
          value: "rapid",
          metadata: null,
        },
        temperature_threshold: {
          id: 0,
          value: 37.3,
          metadata: null,
        },
        send_via_email: 0,
        send_to_email: "",
        send_via_sms: 0,
        send_to_email_sms: "",
        host: null,
        attendance_mode: null,
        notify_host: 0,
        allow_not_select_host: 0,
        granted_message: "Welcome",
        denied_message: "Please seek assistance",
        enable_weigand_output: true,
        weigand_output_settings: [{ id: "rfid", name: "RFID" }],
        remote_sign_in: 0,
      },
      can_type_email: false,
      selectedFlow: null,
      userType: null,
      input: null,
      output: null,
      is_reg_not_required: false,
      outputs: [],
      feedback: null,
      feedbacks: [],
      notification: null,
      notifications: [],
      compliance: null,
      complianceToogle: "daily",
      complianceSettings: [],
      addedNodes: [],
      complianceAddedToDiagram: false,
      touch_mode: false,
      check_register_counter: 0,
      selected_register_not_required: false,
      deleted_user_type_id: [],
      default_selected_register_not_required: null,
      showAttendanceModes: false,
      attendanceModesMessage: "",
      unpermittedUserTypeMessage: this.$t(
        "customFields.form.notPermittedRemove"
      ),
      showHostsUnpermittedUserTypeMessage: false,
      showUserTypeUnpermittedMessage: false,
      disableJourneyInputs: false,
      getJourneyDetails: null,
      getFlowsandTypes: null,
      loading: true,
      disableAttendanceMode: false,
      disabledAttendanceModeMessage: this.$t(
        "journeyBuilder.notes.attendanceModeAccess"
      ),
      journeyFlowCountsWithRemoteSignedInUsers: 0,
      showInputNoteForMulitpleFlow: false,
      showInputNoteForSingleFlow: false,
      // inputNoteForMultipleFlow: this.$t(
      //   "journeyBuilder.notes.removeRemoteOption"
      // ),
      inputNoteForSingleFlow:
        this.$t('journeyBuilder.removeRemote'),
      sectionNote: this.$t("journeyBuilder.notes.companyPlan"),
    };
  },
  watch: {
    "settings.host"(hosts) {
      if (!this.touch_mode || !hosts?.length) {
        this.hostSetting.notify_host.value = false;
        if (!this.hostSetting.isDisabledAllowNotSelectHost)
          this.hostSetting.allow_not_select_host.value = false;
        this.removeNodeAfterClearInput(hosts, this.hostText);
      }
    },
    // "settings.attendance_mode"() {
    //   if (!this.settings.attendance_mode) {
    //     //remove attendance mode (late sign in - early sign out) from notificatio node
    //     const currentSelectedNotification =
    //       this.notification?.filter(
    //         (not) =>
    //           not.name != "early_signout_alert" &&
    //           not.name != "late_signin_alert"
    //       ) || [];

    //     if (currentSelectedNotification.length)
    //       this.editNode(this.notificationText, currentSelectedNotification);

    //     this.removeNodeAfterClearInput(
    //       this.settings.attendance_mode,
    //       this.attendanceModeText
    //     );
    //   }
    // },
    "scene.nodes"(nodes) {
      const nodesList = cloneDeep(nodes);
      const checkLastIndex = nodesList.length > 0 && nodesList.slice(-1)[0];
      nodesList.length > 0
        ? nodesList.map((node) => {
            // check compliance added to digram
            if (node.type == this.complianceText) {
              this.complianceAddedToDiagram = true;
            }
            // check index
            let move = this.moveElementIndex;
            let elementIndex = nodesList.indexOf(node);
            switch (node.type) {
              case this.userTypeText:
                return move(nodesList, elementIndex, 0);
              case this.inputText:
                return move(nodesList, elementIndex, 1);
              case this.checksText:
                return move(nodesList, elementIndex, 2);
              case this.complianceText:
                return move(nodesList, elementIndex, 3);
              case this.outputText:
                return move(nodesList, elementIndex, 4);
              case this.notificationText:
                return move(
                  nodesList,
                  elementIndex,
                  checkLastIndex.type == this.feedbackText
                    ? nodesList.length - 2
                    : nodesList.length + 1
                );
              case this.feedbackText:
                return move(nodesList, elementIndex, nodesList.length + 1);
              default:
                null;
            }
          })
        : [];
    },
    userType(userType) {
      if (!userType?.length)
        this.removeNodeAfterClearInput(userType, this.userTypeText);

      //Disable other 'registeration_not_required' types if there is one already selected (max:1)
      const registerationNotRequiredType = userType?.find(
        (type) => type.pre_registration_method === "REGISTRATION_NOT_REQUIRED"
      );

      if (registerationNotRequiredType && !this.touch_mode) {
        this.userTypesOptions = this.userTypesOptions?.map((type) => {
          if (
            type.pre_registration_method === "REGISTRATION_NOT_REQUIRED" &&
            type.id !== registerationNotRequiredType?.id
          )
            type.$isDisabled = true;
          return type;
        });
      } else {
        this.userTypesOptions = this.userTypesOptions?.map((type) => {
          if (
            type.pre_registration_method === "REGISTRATION_NOT_REQUIRED" &&
            type.isUsedInAnthorFlow === false &&
            type.permitted
          )
            type.$isDisabled = false;
          return type;
        });
      }

      //Flag to indicates if there's a "registeration_not_required" type selected
      this.selected_register_not_required = !!registerationNotRequiredType;

      //Disable journey builder inputs (multiselect) if all user types are selected + unpermitted
      const hasPermitted = userType?.some((type) => !!type.permitted);
      this.disableJourneyInputs = !hasPermitted;

      //Show attendnace input if 'Pre_registered_by_admin' is selected
      const hasPreRegisteredByAdmin = userType?.some(
        (type) => type.pre_registration_method == "PRE_REGISTERED_BY_ADMIN"
      );
      this.showAttendanceModes = hasPreRegisteredByAdmin;

      //Reset attendance mode value if no pre registered by admin was selected and node was removed
      if (!hasPreRegisteredByAdmin) this.settings.attendance_mode = null;

      //Set attendance mode note message
      this.checkUserTypesWithModes();

      //Input note handler
      this.setInputNote();
    },
    input(input) {
      this.isFaceRecognition = input?.some(
        (item) => item.name === "facial_recognition"
      );

      this.isRemoteSignInSelected = input?.some(
        (item) => item.name === "remote_sign_in"
      );

      //Reset input remote settings if its deselected
      if (!this.isRemoteSignInSelected)
        this.remoteSettings.value = "not_required";

      const inputValue = JSON.parse(JSON.stringify(input));
      this.removeNodeAfterClearInput(inputValue, this.inputText);

      //Input note handler
      this.setInputNote();
    },
    check(check) {
      //Show checks settings only if 'Temperature check' is selected
      this.checkSetting = check?.some(
        (check) => check.name === "temperature_check"
      );

      // remove node after clear check input
      this.removeNodeAfterClearInput(check, this.checksText);
    },
    compliance(compliance) {
      // remove node after clear compliance input
      const inputValue = JSON.parse(JSON.stringify(compliance));
      this.removeNodeAfterClearInput(inputValue, this.complianceText);
    },
    section(section) {
      this.removeNodeAfterClearInput(section, this.sectionText);
    },
    output(output) {
      const hasOutput = !!output?.length;
      const hasoutputConfig = output?.some(
        (opt) => opt.name == "door_relay" || opt.name == "print_badge"
      );

      // if (!hasOutput) {
      //   this.outputSetting?.forEach((setting) => {
      //     if (setting.name == "weigand_output_settings" || setting.id == 62)
      //       setting.value = { id: "rfid", name: "RFID" };
      //     else setting.value = false;
      //   });
      // }
      this.setWeigandSettings();

      if (!hasOutput || !hasoutputConfig) {
        this.outputs?.forEach((output) => {
          if (output.name != "save_data" && output.id != 34) {
            output.signIn = true;
            output.signOut = false;
            output.checkIn = true;
          }
        });
      }
      this.isOutputSetting = hasOutput;
      this.removeNodeAfterClearInput(output, this.outputText);
    },
    feedback(feedback) {
      // remove node after clear compliance input
      const inputValue = JSON.parse(JSON.stringify(feedback));
      this.removeNodeAfterClearInput(inputValue, this.feedbackText);
      // settings
      if (feedback && feedback.length > 0) {
        this.isFeedbackSetting = true;
      }
    },
    notification(notification) {
      // remove node after clear compliance input
      const inputValue = JSON.parse(JSON.stringify(notification));
      this.removeNodeAfterClearInput(inputValue, this.notificationText);

      //reset settings
      if (!notification?.length) {
        this.notificationSettingModel.send_to_email.value = false;
        this.notificationSettingModel.send_via_email.value = false;
      }
    },
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("journeyBuilder", ["getLoading"]),
    ...mapGetters("authfack", ["getCurrentPlan"]),
    isTemerpatureCheckSelected() {
      return this.check?.some((ch) => ch.name == "temperature_check");
    },
    isHostSelected() {
      return !!this.settings.host?.length;
    },
    isAttendanceModeSelected() {
      return !!this.settings.attendance_mode;
    },
    watchFlowNodes() {
      const { nodes } = this.scene.diagram;
      return nodes;
    },
    getNodeType() {
      const { nodes } = this.scene;
      return nodes.length > 0 ? nodes.map((node) => node.type) : ["no type"];
    },
    checkRoute() {
      return this.currentRoute == "updateJourney" ||
        this.currentRoute == "addJourney"
        ? true
        : false;
    },
    checkMainNodes() {
      return this.userType &&
        this.userType.length > 0 &&
        ((this.input && this.input.length > 0) || this.touch_mode) &&
        this.feedback &&
        this.feedback.length > 0
        ? true
        : false;
    },
    checkFlowInfo() {
      return this.name && this.description ? true : false;
    },
    getFlows() {
      return Object.keys(this.getFlowsandTypes).length > 0
        ? this.getFlowsandTypes.journeyFlows
        : [];
    },
    applySection() {
      return this.getCurrentPlan == 2 || this.getCurrentPlan == 3;
    },
  },
  methods: {
    ...mapActions("journeyBuilder", [
      "addJourney",
      "updateJourney",
      "validateJourneyFlow",
    ]),
    attendanceModeDeselect(){
      this.settings.attendance_mode = null;
      this.removeNodeAfterClearInput(this.settings.attendance_mode,this.attendanceModeText)
    },
    onOutputSelect() {
      const hasOutput = !!this.output?.length;

      if (hasOutput) this.output = orderBy(this.output, "index");
    },
    setInputNote() {
      this.inputGeofencingApplicableUserTypes = [];
      this.formattedGeofencingUserTypes = "";
      //show input note at least one "pre_registered_by_admin" user type is selected (CL-9138)
      this.inputGeofenceSelected = this.input?.some((inp) => inp.id == 109);

      //Select type pre reg by admin , or any type with children pre preg by admin
      const preRegByAdminSelected = this.userType?.filter(
        (type) =>
          type.pre_registration_method === "PRE_REGISTERED_BY_ADMIN" ||
          type.pre_registered_by_admin_children?.length > 0
      );

      if (this.inputGeofenceSelected && !!preRegByAdminSelected.length) {
        this.showGeoFencingNote = true;
        preRegByAdminSelected.forEach((type) => {
          //Only add parent if type is pre reg by admin
          if (type.pre_registration_method === "PRE_REGISTERED_BY_ADMIN")
            this.inputGeofencingApplicableUserTypes.push(type);
          type.pre_registered_by_admin_children?.forEach((child) => {
            this.inputGeofencingApplicableUserTypes.push(child);
          });
        });

        this.inputGeofencingApplicableUserTypes = uniqBy(
          this.inputGeofencingApplicableUserTypes,
          "id"
        );
        this.inputGeofencingApplicableUserTypes =
          this.inputGeofencingApplicableUserTypes?.map((type) => type.name);

        if (this.inputGeofencingApplicableUserTypes.length == 1)
          this.formattedGeofencingUserTypes = `"${this.inputGeofencingApplicableUserTypes[0]}"`;
        else if (this.inputGeofencingApplicableUserTypes.length == 2)
          this.formattedGeofencingUserTypes =
            '"' + this.inputGeofencingApplicableUserTypes.join('" and "') + '"';
        else if (this.inputGeofencingApplicableUserTypes.length > 2) {
          const lastUserType = this.inputGeofencingApplicableUserTypes.pop();

          this.formattedGeofencingUserTypes =
            '"' +
            this.inputGeofencingApplicableUserTypes.join('" , "') +
            '"' +
            ` and "${lastUserType}"`;
        }
      } else this.showGeoFencingNote = false;
    },
    deselectOutput(deselected) {
      if (deselected?.id == 34) return;
      deselected.signIn = true;
      deselected.signOut = false;
      deselected.checkIn = true;
    },
    resetChecksSettings(deselected) {
      if (deselected.id == "3" || deselected.name == "temperature_check") {
        this.checksSetting.temperature_check_type.value = "rapid";
        this.checksSetting.temperature_threshold.value =
          this.companyTemp?.toLowerCase() == "f" ? 99.1 : 37.3;
      }
    },
    updateInputGeo(geoSetting) {
      this.remoteSettings = geoSetting;
    },
    updateFlowChecks(flowChecks) {
      this.checksSetting = flowChecks;
    },
    updateOutput(outputSettings) {
      this.output = outputSettings;
    },
    removeOutput(deselectOutput) {
      this.output = this.output.filter(
        (output) => output.name !== deselectOutput.name
      );
    },
    undoOutputChanges(outputSettings) {
      this.output = outputSettings;
    },
    updateNotification(notificationSettings) {
      this.notificationSettingModel.send_to_email =
        notificationSettings.settings.send_to_email;
      this.notificationSettingModel.send_via_email =
        notificationSettings.settings.send_via_email;
      this.notificationSettingModel.late_signin_alert =
        notificationSettings.settings.late_signin_alert;
      this.notificationSettingModel.early_signout_alert =
        notificationSettings.settings.early_signout_alert;
    },
    updateFeedback({ settings }) {
      this.feedbackSetting = Object.keys(settings)?.map((key) => settings[key]);
    },
    updateHost(hostSettings) {
      this.hostSetting = hostSettings;
    },
    removeUserTypeHandler(userTypeId) {
      this.userType = this.userType?.filter((type) => type.id != userTypeId);
      this.checkNodeType(this.userTypeText)
        ? this.editNode(this.userTypeText, this.userType)
        : this.addNode(this.userTypeText, this.userType, 0, 100);
    },
    removeHostHandler(hostId) {
      this.settings.host = this.settings.host?.filter(
        (host) => host.id != hostId
      );
      this.checkNodeType(this.hostText)
        ? this.editNode(this.hostText, this.settings.host)
        : this.addNode(this.hostText, this.settings.host, 480, 100);
    },
    removeInputHandler(inputId) {
      this.input = this.input?.filter((inp) => inp.id != inputId);
      this.checkNodeType(this.inputText)
        ? this.editNode(this.inputText, this.input)
        : this.addNode(this.inputText, this.input, 120, 100);
    },
    onComplianceSettingsCanceled(previousOnlineCompliancesSettings) {
      this.onlineComplianceSettings = previousOnlineCompliancesSettings;
    },
    onRemoveUserType(selectedUserType) {
      //check if selected user type is allowed for online compliance setting
      const userTypeHasSettings = this.onlineComplianceAllowedUserTypes.some(
        (type) => type == selectedUserType.pre_registration_method
      );
      if (userTypeHasSettings) {
        for (const key in this.onlineComplianceSettings) {
          this.onlineComplianceSettings[key]?.forEach((compliance) => {
            if (
              compliance.metadata.notification &&
              compliance.metadata.notification.length
            ) {
              compliance.metadata.notification =
                compliance.metadata.notification.filter(
                  (setting) => setting.userTypeId != selectedUserType.id
                );
            }
          });
        }
      }
    },
    onSelectUserType(selectedUserType) {
      //check if selected user type is allowed for online compliance setting
      const userTypeHasSettings = this.onlineComplianceAllowedUserTypes.some(
        (type) => type == selectedUserType.pre_registration_method
      );
      if (userTypeHasSettings) {
        let defaultUserTypeSetting = {
          periodOfTimeToSendBeforeVisit: 1,
          periodOfTimeToSendReminderVisit: 6,
          typeOfTimeToSendBeforeVisit: this.userTypeSettingsOption[2],
          typeOfTimeToSendReminderVisit: this.userTypeSettingsOption[1],
        };
        Object.assign(defaultUserTypeSetting, {
          userTypeId: selectedUserType.id,
          name: selectedUserType.name,
        });

        //Add new user type to all online compliance settings
        for (const key in this.onlineComplianceSettings) {
          this.onlineComplianceSettings[key]?.forEach((compliance) => {
            compliance.metadata.notification.push(defaultUserTypeSetting);
          });
        }
      }
    },
    async checkUserTypesWithModes() {
      if (!this.userType?.length) return;

      this.attendanceModesMessage = "";
      let userTypesNames = [];

      this.userType.forEach((type) => {
        const isPreRegByAdmin =
          type.pre_registration_method == "PRE_REGISTERED_BY_ADMIN";

        if (isPreRegByAdmin) {
          userTypesNames.push(type.name);
          const children = type.pre_registered_by_admin_children || [];
          children?.forEach((child) => userTypesNames.push(child.name));
        }
      });
      if (userTypesNames.length) {
        let uniqueStrings = [...new Set(userTypesNames)];
        let lastUserType = uniqueStrings.pop();
        let userTypesNamesStrings = '"' + uniqueStrings.join('" , "') + '"';
        if (userTypesNamesStrings && userTypesNamesStrings != '""')
          this.attendanceModesMessage = `${this.$t(
            "journeyBuilder.attendanceModeNote"
          )} ${this.$t("journeyBuilder.attendanceModeNoteUserTypes", {
            types: userTypesNamesStrings,
          })} ${this.$t("journeyBuilder.and")} "${lastUserType}" ${
            this.getLanguage == "en" ? "users ." : ""
          }`;
        else
          this.attendanceModesMessage = this.$t('journeyBuilder.attendnaceModeApply', {userType: lastUserType});
      }
    },
    updateComplianceMetadata(selectedCompliance) {
      let metadataNotification = [];

      this.userType?.forEach((userType) => {
        //check if selected user type is allowed for online compliance setting
        const userTypeHasSettings = this.onlineComplianceAllowedUserTypes.some(
          (type) => type == userType.pre_registration_method
        );
        if (userTypeHasSettings) {
          let defaultUserTypeSetting = {
            periodOfTimeToSendBeforeVisit: 1,
            periodOfTimeToSendReminderVisit: 6,
            typeOfTimeToSendBeforeVisit: this.userTypeSettingsOption[2],
            typeOfTimeToSendReminderVisit: this.userTypeSettingsOption[1],
          };
          Object.assign(defaultUserTypeSetting, {
            userTypeId: userType.id,
            name: userType.name,
          });
          metadataNotification.push(defaultUserTypeSetting);
        }
      });

      const complianceObject = {};
      Object.assign(complianceObject, {
        id: selectedCompliance.id,
        name: selectedCompliance.name,
        setting: "every_time",
        type: selectedCompliance.type,
        metadata: { notification: metadataNotification },
      });

      let type = "";
      switch (complianceObject.type) {
        case "agreement":
            type = this.$t("common.agreement");
            break;
        case "questionnaire":
          type = this.$t("common.questionnaire");
          break;
        case "vaccine_document":
          type = this.$t("common.documentVaccinePcr");
      }
      if (this.onlineComplianceSettings[type]) {
        this.onlineComplianceSettings[type].push(complianceObject);
      } else {
        this.onlineComplianceSettings[type] = [complianceObject];
      }
    },
    removeSection() {},
    removeCompliance(selectedCompliance) {
      let type = "";
      switch (selectedCompliance.type) {
        case "agreement":
          type = this.$t("common.agreement");
          break;
        case "questionnaire":
          type = this.$t("common.questionnaire");
          break;
        case "vaccine_document":
          type = this.$t("common.documentVaccinePcr");
      }
      if (
        this.onlineComplianceSettings[type] &&
        this.onlineComplianceSettings[type].length > 1
      ) {
        this.onlineComplianceSettings[type] = this.onlineComplianceSettings[
          type
        ].filter((compliance) => {
          return compliance.id != selectedCompliance.id;
        });
      } else {
        delete this.onlineComplianceSettings[type];
      }
    },
    // onSubmit
    async onBuilderSubmit() {
      if (!this.scene.nodes?.length)
        this.$toast.error("You should add the required nodes on right side", {
          position: "top-right",
        });
      else if (!this.checkMainNodes)
        this.$toast.error(
          `Journey should have User type${
            this.touch_mode ? "" : ", input"
          } and feedback nodes!`,
          {
            position: "top-right",
          }
        );
      else if (!this.checkFlowInfo)
        this.$toast.error("Please enter journey flow name and description!", {
          position: "top-right",
        });
      else {
        let settings = [];

        //Input
        this.input?.forEach((input) => {
          settings.push({
            id: input.id,
            value: "1",
            metadata: input.metadata,
          });
        });

        //Set value of unselected input to false and add to setting
        const deselectedInputs = differenceBy(
          this.inputSettings,
          this.input,
          "id"
        );
        deselectedInputs?.forEach((input) => {
          settings.push({
            id: input.id,
            value: "0",
            metadata: input.metadata,
          });
        });

        //remote input setting (geofence)
        settings.push({
          id: this.remoteSettings.id,
          metadata: null,
          value: this.remoteSettings.value,
        });

        //Checks
        const deselectedChecks = differenceBy(
          this.checksOptions,
          this.check,
          "id"
        );
        this.check?.forEach((check) => {
          settings.push({
            id: check.id,
            value: "1",
            metadata: check.metadata,
          });
        });

        deselectedChecks?.forEach((check) => {
          settings.push({
            id: check.id,
            value: "0",
            metadata: check.metadata,
          });
        });
        //checks settings
        if (this.checksSetting.company_temp_unit === "f")
          this.checksSetting.temperature_threshold.value = this.setToCelcius(
            this.checksSetting.temperature_threshold.value
          );

        Object.keys(this.checksSetting)?.forEach((checksKey) => {
          if (checksKey != "company_temp_unit") {
            this.checksSetting[checksKey].value =
              this.checksSetting[checksKey].value?.toString();
            settings.push(this.checksSetting[checksKey]);
          }
        });

        //Compliance
        let complianceSettingsFlattened = [];
        for (let key in this.onlineComplianceSettings) {
          this.onlineComplianceSettings[key]?.forEach((typeSetting) => {
         typeSetting.metadata.notification?.forEach(notification=>{
              Object.assign(notification,{ typeOfTimeToSendBeforeVisit : this.getTimeTypeById(notification.typeOfTimeToSendBeforeVisit.id),
              typeOfTimeToSendReminderVisit : this.getTimeTypeById(notification.typeOfTimeToSendReminderVisit.id) })
            })
            complianceSettingsFlattened.push(typeSetting);
          });
        }

        //Section
        settings.push({
          id: this.sectionObject.id,
          metadata: null,
          value: this.applySection
            ? this.section?.map((section) => section.id)?.join(",")
            : null,
        });

        //Output
        const deselectedOutputs = differenceBy(this.outputs, this.output, "id");

        this.output?.forEach((output) => {
          //Add weigand setting
          if (output.id == "61") {
            let value = "";
            let selectedWeigandSettings =
              output.chlidren.weigand_output_settings.value.filter(
                (opt) => opt.value
              );
            selectedWeigandSettings = selectedWeigandSettings.map(
              (opt) => opt.id
            );

            value = selectedWeigandSettings.length
              ? selectedWeigandSettings.join(",")
              : "rfid";

            settings.push({
              id: "62",
              value: value,
              metadata: null,
            });
          }

          let loginMode = [];

          if (output.signIn) loginMode.push(3);
          if (output.signOut) loginMode.push(4);
          if (output.checkIn) loginMode.push(1);

          if (output.chlidren) {
            Object.keys(output.chlidren).forEach((key) => {
              if (output.chlidren[key].id != "62") {
                let value = output.chlidren[key].value ? "1" : "0";
                settings.push({
                  id: output.chlidren[key].id,
                  value: value,
                  metadata: output.chlidren[key].metadata,
                });
              }
            });
          }

          settings.push({
            id: output.id,
            value: "1",
            metadata: JSON.stringify({ loginMode }),
          });
        });

        deselectedOutputs?.forEach((output) => {
          //Add weigand setting
          if (output.id == "61") {
            let value = "";

            let selectedWeigandSettings =
              Array.isArray(output.chlidren.weigand_output_settings.value) &&
              output.chlidren.weigand_output_settings.value?.filter(
                (opt) => opt.value
              );

            selectedWeigandSettings =
              Array.isArray(selectedWeigandSettings) &&
              selectedWeigandSettings.map((opt) => opt.id);

            value =
              Array.isArray(selectedWeigandSettings) &&
              selectedWeigandSettings.length
                ? selectedWeigandSettings.join(",")
                : "rfid";

            settings.push({
              id: "62",
              value: value,
              metadata: null,
            });
          }

          let loginMode = [];

          if (output.signIn) loginMode.push(3);
          if (output.signOut) loginMode.push(4);
          if (output.checkIn) loginMode.push(1);

          //Set defaults in case user deselected all login modes on adding a flow
          if (
            output.signIn === false &&
            output.signOut === false &&
            output.checkIn === false
          ) {
            loginMode = [1, 3];
          }

          if (output.chlidren) {
            Object.keys(output.chlidren).forEach((key) => {
              if (output.chlidren[key].id != "62") {
                let value = output.chlidren[key].value ? "1" : "0";
                settings.push({
                  id: output.chlidren[key].id,
                  value: value,
                  metadata: output.chlidren[key].metadata,
                });
              }
            });
          }

          settings.push({
            id: output.id,
            value: "0",
            metadata: JSON.stringify({ loginMode }),
          });
        });

        //Notification
        const deselectedNotifications = differenceBy(
          this.allNotificationSettings,
          this.notification,
          "id"
        );

        this.notification?.forEach((notification) => {
          let metadata = [];
          if (notification.id == 105) {
            this.notificationSettingModel.late_signin_alert.metadata?.forEach(
              (opt) => {
                if (opt.isPresented) {
                  //find if reason id already added
                  let reason = metadata?.find(
                    (reason) => reason.id == opt.reason_id
                  );
                  if (reason) reason.presented.push(opt.label);
                  else
                    metadata.push({
                      id: opt.reason_id,
                      presented: [opt.label],
                    });
                } else metadata.push(opt);
              }
            );
            settings.push({
              id: notification.id,
              value: "1",
              metadata: { reason: metadata },
            });
          } else if (notification.id == 106) {
            this.notificationSettingModel.early_signout_alert.metadata?.forEach(
              (opt) => {
                if (opt.isPresented) {
                  //find if reason id already added
                  let reason = metadata?.find(
                    (reason) => reason.id == opt.reason_id
                  );
                  if (reason) reason.presented.push(opt.label);
                  else
                    metadata.push({
                      id: opt.reason_id,
                      presented: [opt.label],
                    });
                } else metadata.push(opt);
              }
            );
            settings.push({
              id: notification.id,
              value: "1",
              metadata: { reason: metadata },
            });
          } else {
            settings.push({
              id: notification.id,
              value: "1",
              metadata: notification.metadata,
            });
          }
        });

        deselectedNotifications.forEach((notification) => {
          settings.push({
            id: notification.id,
            value: "0",
            metadataData: notification.metadata,
          });
        });

        //notification settings

        //Get all notification settings in an array (send_to_email ,send_via_email ,send_to_sms ,send_via_sms)
        let notificationAllChildrenSettings = this.allNotificationSettings.find(
          (opt) => opt.id == 104
        )?.chlidren;
        notificationAllChildrenSettings =
          notificationAllChildrenSettings &&
          Object.keys(notificationAllChildrenSettings)?.map(
            (key) => notificationAllChildrenSettings[key]
          );

        // notificationSettings => send_to_email & send_via_email settings to set values (true , 'ex@test.com')
        const notificationChildrenSettings = Object.keys(
          this.notificationSettingModel
        )?.map((key) => this.notificationSettingModel[key]);

        //Get unused/deselected notification settings to set values to false
        const deselectedNotificationSettings = differenceBy(
          notificationAllChildrenSettings,
          notificationChildrenSettings,
          "id"
        );

        notificationChildrenSettings?.forEach((setting) => {
          if (setting.type != "metadata") {
            let value = "";
            if (setting.type == "boolean") value = setting.value ? "1" : "0";
            else if (setting.type == "string")
              value = setting.value ? setting.value : null;

            settings.push({
              id: setting.id,
              value,
              metadata: setting.metadata,
            });
          }
        });

        deselectedNotificationSettings?.forEach((setting) => {
          if (setting.type != "metadata") {
            let value = "";
            if (setting.type == "boolean") value = setting.value ? "1" : "0";
            else if (setting.type == "string")
              value = setting.value ? setting.value : null;

            settings.push({
              id: setting.id,
              value,
              metadata: setting.metadata,
            });
          }
        });

        //Feedback
        const deselectedFeedback = differenceBy(
          this.allFeedbackSettings,
          this.feedback,
          "id"
        );

        this.feedback?.forEach((feedback) => {
          settings.push({
            id: feedback.id,
            value: "1",
            metadata: feedback.metadata,
          });
        });

        deselectedFeedback?.forEach((feedback) => {
          settings.push({
            id: feedback.id,
            value: "0",
            metadata: feedback.metadata,
          });
        });

        //Feedback settings (granted message ,denied message ...)
        this.feedbackSetting?.forEach((setting) => {
          settings.push({
            id: setting.id,
            value: setting.value,
            metadata: setting.metadata,
          });
        });

        //Host + Attendance mode
        Object.keys(this.hostSetting)?.forEach((key) => {
          if (key !== "isDisabledAllowNotSelectHost")
            settings.push({
              id: this.hostSetting[key].id,
              value: this.hostSetting[key].value ? "1" : "0",
              metadata: this.hostSetting[key].metadata,
            });
        });

        settings.push(
          {
            id: this.hostSettingObject.id,
            value:
              this.settings.host?.map((host) => host.id)?.join(",") || null,
            metadata: this.hostSettingObject.metadata,
          },
          {
            id: this.attendanceModeObject.id,
            value: this.settings.attendance_mode?.id || null,
            metadata: this.attendanceModeObject.metadata,
          }
        );

        const data = {
          flow: {
            name: this.name,
            journey_flow_id: this.journeyFlowId,
            description: this.description,
            journey_id: this.journeyId,
          },
          diagram: this.scene.nodes,
          compliance: complianceSettingsFlattened,
          settings,
          userTypeIds: this.userType?.map((type) => type.id),
        };

        if (this.$route.name === "updateFlow") {
          const inputs = [];
          this.input?.forEach((item) => {
            inputs.push(item.id);
          });

          if (inputs.length) {
            const inputHasChanged = !isEqual(this.input, this.inputOnMount);

            //only validate if input value has changed (since mount)
            if (inputHasChanged) {
              const validateResponse = await this.validateJourneyFlow({
                journey_id: this.journeyId,
                journey_flow_id: this.journeyFlowId,
                inputs,
              });

              if (!validateResponse.data) {
                this.$toast.error(
                  "Journey should have an input method beside “Remote” because it is assigned to an area or kiosk",
                  {
                    position: "top-right",
                  }
                );
                return;
              }
            }
          }

          //Reverse diagram translation (revert <label,type> to english before submit)
          this.scene.nodes.forEach(node=>{
            Object.assign (node,{type: this.reverseTranslateNodeType(node.type),label:this.reverseTranslateNodeLabel(node)})
          })

          await this.updateJourney({
            payload: data,
            flowId: this.journeyFlowId,
          });
        } else {
          await this.addJourney(data);
        }
      }
    },
    // links
    addDynamicLinks(nodes) {
      let nodesList = JSON.parse(JSON.stringify(nodes));
      let nodesValue =
        nodesList.length > 0 &&
        nodesList.slice(nodesList.length - 2, nodesList.length);
      if (nodesValue.length > 1) {
        this.scene.links.push({ nodes: [nodesValue[0].id, nodesValue[1].id] });
      }
    },
    moveElementIndex(arr, fromIndex, toIndex) {
      let element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    },
    getIndexOfArr(arr, element) {
      arr.indexOf(element);
    },
    // nodes
    nodeObject(type, label, y, x) {
      return {
        id: type,
        x: -700 + (x ? x : 0),
        y: -80 + (y ? y : 0),
        type: type,
        data: this.checkArray(label)
          ? label.map((value) => value.id).join(",")
          : label.id,
        label: this.checkArray(label)
          ? label.map((value) => value.label || value.name).join(", ")
          : label.name,
      };
    },
    translateNodeType(type){
     switch(type){
        case "Compliance":
          return this.$t('common.compliance');
        case "Checks":
          return this.$t('common.checks');
        case "Input":
          return this.$t('common.input');
        case "User Type":
          return this.$t('common.userType');
        case "Section":
          return this.$t('journeyBuilder.flow.section');
        case "Host":
          return this.$t('common.host');
        case "Output":
          return this.$t('common.output');
        case "Notifications":
          return this.$t('common.notifications');
        case "Feedback":
          return this.$t('common.feedback');
        case "Attendance Mode":
          return this.$t('attendanceModes.attendanceMode');
      }
    },
    reverseTranslateNodeType(type){
      switch(type){
        case  this.$t('common.compliance'):
          return "Compliance";
        case this.$t('common.checks'):
          return "Checks";
        case this.$t('common.input'):
          return "Input";
        case this.$t('common.userType'):
          return "User Type";
        case this.$t('journeyBuilder.flow.section'):
          return "Section";
        case this.$t('common.host'):
          return "Host";
        case this.$t('common.output'):
          return "Output";
        case this.$t('common.notifications'):
        // case this.$t('common.notifications'):
          return "Notifications";
        case this.$t('common.feedback'):
          return "Feedback";
        case this.$t('attendanceModes.attendanceMode'):
          return "Attendance Mode";
      }
    },
    reverseTranslateNodeLabel(node) {
       const savedList = [
        "وسيلة الدخول",
        "Input",
        "الفحوصات",
        "Checks",
        "المخرجات",
        "Output",
        "Feedback",
        "تفاعل الكيوسك",
        "Notifications",
        "إشعار",
      ];

      const translatteNode = savedList.indexOf(node.id) > -1

      const result = [];
      if (translatteNode) {
        const valuesArr = node.label.split(",");

        valuesArr.forEach((value) => {
          if (node.id == "الفحوصات" || node.id == "Checks") {
            switch (value) {
              case "التحقق من درجة الحرارة":
              case " التحقق من درجة الحرارة":
                result.push("Temperature Check");
                break;

              case " التحقق من الكمامة":
              case "التحقق من الكمامة":
                result.push("Mask Check");
                break;
              default:
                result.push(value);
            }
          } else if (node.id == "وسيلة الدخول" || node.id == "Input") {
            switch (value) {
              case "التعرف على الوجه":
              case " التعرف على الوجه":
                result.push("Face Recognition");
                break;

              case " تطبيق الجوال (العمل عن بُعد)":
              case "تطبيق الجوال (العمل عن بُعد)":
                result.push("Mobile App (Remote Work)");
                break;

              case "تطبيق الجوال (السياج الجغرافي للموقع)":
              case " تطبيق الجوال (السياج الجغرافي للموقع)":
                result.push("Mobile App (Site Geofence)");
                break;

              case "RFID":
                result.push("RFID");
                break;

              case "رمز QR":
              case " رمز QR":
                result.push("QR Code");
                break;
              default:
                result.push(value);
                break;
            }
          } else if (node.id == "المخرجات" || node.id == "Output") {
            switch (value) {
              case "فتح الباب":
              case " فتح الباب":
                result.push("Door Relay");
                break;

              case " حفظ البيانات":
              case "حفظ البيانات":
                result.push("Save Data");
                break;

              case " مخرج الـ Weigand":
              case "مخرج الـ Weigand":
                result.push("Weigand output");
                break;

              case " طباعة بطاقة التعريف":
              case "طباعة بطاقة التعريف":
                result.push("Print Badge");
                break;
              default:
                result.push(value);
                break;
            }
          } else if (node.id == "تفاعل الكيوسك" || node.id == "Feedback") {
            switch(value){
              case " صوت":
              case "صوت":
                result.push("Audio");
                break;

              case "درجة الحرارة":
                result.push("Temperature");
                break;

              case "ضوء":
              case " ضوء":
                result.push("Light");
                break;
              default:
                result.push(value);
                break;
            }
          }else if(node.id == "إشعار" || node.id == "Notifications"){
            switch(value){
              case "تنبيه درجة الحرارة":
              case " تنبيه درجة الحرارة":
                result.push("Temperature Alert");
                break;

              case "تنبيه الكمامة":
              case " تنبيه الكمامة":
                result.push("Mask Alert");
                break;

              case "تنبيه شروط الدخول":
              case " تنبيه شروط الدخول":
                result.push("Compliance Alert");
                break;

              case "تنبيه تسجيل الدخول المتأخر":
              case " تنبيه تسجيل الدخول المتأخر":
                result.push("Late Sign In Alert");
                break;

              case "تنبيه تسجيل الخروج المبكر":
              case " تنبيه تسجيل الخروج المبكر":
                result.push("Early Sign Out Alert");
                break;
              default:
                result.push(value);
                break;
            }
          }
        });
      }
      return translatteNode ? result?.join(",") : node.label;
    },
    addNode(type, label, y, x) {
      if (type == this.checksText) {
        //Check if mask is selected
        const isMaskCheck = this.check?.find((item) => item.name == "Mask");
        this.settings.mask_check = isMaskCheck ? true : false;

        //Check if temperature is selected
        const isTemperatureCheck = this.check?.find(
          (item) => item.name == "Temperature"
        );
        this.settings.temperature_check = isTemperatureCheck ? true : false;
      } else if (type == this.inputText) {
        //Check if remote sign in is selected
        const isRemoteSignIn = this.input?.find(
          (item) => item.name == "remote_sign_in"
        );
        this.settings.remote_sign_in = isRemoteSignIn ? 1 : 0;
      }

      switch (type) {
        case this.userTypeText:
          return this.scene.nodes.splice(
            0,
            0,
            this.nodeObject(type, label, y, x)
          );
        case this.inputText:
          return this.scene.nodes.splice(
            1,
            0,
            this.nodeObject(type, label, y, x)
          );
        case this.checksText:
          return this.scene.nodes.splice(
            2,
            0,
            this.nodeObject(type, label, y, x)
          );
        case this.complianceText:
          return this.scene.nodes.splice(
            3,
            0,
            this.nodeObject(type, label, y, x)
          );
        case this.sectionText:
          return this.scene.nodes.splice(
            4,
            0,
            this.nodeObject(type, label, y, x)
          );
        case this.hostText:
          return this.scene.nodes.splice(
            5,
            0,
            this.nodeObject(type, label, y, x)
          );
        case this.attendanceModeText:
          return this.scene.nodes.splice(
            6,
            0,
            this.nodeObject(type, label, y, x)
          );
        case this.outputText:
          return this.scene.nodes.splice(
            7,
            0,
            this.nodeObject(type, label, y, x)
          );
        case this.notificationText:
          return this.scene.nodes.splice(
            8,
            0,
            this.nodeObject(type, label, y, x)
          );
        case this.feedbackText:
          return this.scene.nodes.push(this.nodeObject(type, label, y, x));
        default:
          null;
      }
    },
    editNode(type, label) {
      if (type === this.checksText) {
        //Check if mask is selected
        this.settings.mask_check = label?.some(
          (item) => item.name === "mask_check"
        );

        //Check if temperature is selected
        this.settings.temperature_check = label?.some(
          (item) => item.name == "temperature_check"
        );
      } else if (type === this.inputText) {
        this.settings.remote_sign_in = label?.some(
          (item) => item.name == "remote_sign_in"
        );
      }

      const { nodes } = this.scene;
      let objIndex = nodes.findIndex((obj) => obj.type == type); // get index
      let idsArr = this.checkArray(label) // we get journey inputs with ids to assign them to key data
        ? this.getJourneyInputData(nodes[objIndex].type)?.map((item) =>
            label?.map((label) => label.name == item.name && item.id)
          )
        : label?.id; // get update label id

      let labelIds = this.checkArray(idsArr)
        ? idsArr
            .map((ids) => [...new Set(ids)].filter(Boolean))
            .filter(function (el) {
              return (el != el.length) != 0;
            })
        : idsArr; // remove duplicated values

      this.currentRoute == this.addFlowRoute
        ? (nodes[objIndex].data = this.checkArray(label)
            ? label.map((value) => value.id).join(",")
            : label.id)
        : (nodes[objIndex].data = this.checkArray(label)
            ? labelIds.join(",")
            : labelIds); // set data
      nodes[objIndex].label = this.checkArray(label) // set label
        ? label
            .map((value) =>
              type === this.inputText ||
              type === this.checksText ||
              type === this.notificationText ||
              type === this.outputText ||
              type === this.feedbackText
                ? value.label
                : value.name
            )
            .join(", ")
        : label?.name ?? 
        null;
    },
    getJourneyInputData(inputType) {
      switch (inputType) {
        case this.userTypeText:
          return this.userTypesOptions;
        case this.inputText:
          return this.inputTypes;
        case this.checksText:
          return this.checksOptions;
        case this.hostText:
          return this.settings.host;
        case this.attendanceModeText:
          return this.settings.attendance_mode;
        case this.outputText:
          return this.outputs;
        case this.notificationText:
          return this.notifications;
        case this.feedbackText:
          return this.feedbacks;
        case this.complianceText:
          return this.complianceSettings;
        case this.sectionText:
          return this.section;
        default:
          [];
      }
    },
    removeNodeAfterClearInput(input, type) {
      if (input == null || (input && input.length == 0)) {
        this.scene.nodes.map((item) => {
          item.type == type &&
            this.removeParticularItem(this.scene.nodes, item);
          this.scene.links.map((link) => {
            (link.nodes[0] == type || link.nodes[1] == type) &&
              this.removeParticularItem(this.scene.links, link);
          });
        });
      }
      if (type == this.complianceText) {
        this.complianceAddedToDiagram = false;
      }
      if (type == this.checksText) {
        const isMaskCheck = this.check?.find((item) => item.name == "Mask");
        const isTemperatureCheck = this.check?.find(
          (item) => item.name == "Temperature"
        );
        if (!isMaskCheck && !isTemperatureCheck) {
          this.settings.mask_check = false;
          this.settings.temperature_check = false;
        }
      }
    },
    removeParticularItem(arr, value) {
      let itemIndex = arr.indexOf(value);
      arr.splice(itemIndex, 1);
    },
    getArraysIntersection(arr, arr2) {
      return arr.filter((n) => {
        return arr2.indexOf(n) !== -1;
      });
    },
    clearFlowInputs() {
      this.input = null;
      this.check = null;
      this.compliance = null;
      this.output = null;
      this.feedback = null;
      this.notification = null;
      this.settings.host = null;
      this.settings.attendance_mode = null;
    },
    nodeDelete(id) {
      switch (id) {
        case this.userTypeText:
        case "User Type":
          this.userType = null;
          break;

        case this.inputText:
        case "Input":
          this.input = null;
          break;

        case this.checksText:
        case "Checks":
          this.check = null;
          break;

        case this.hostText:
        case "Host":
          this.settings.host = null;
          break;

        case this.attendanceModeText:
        case "Attendance Mode":
          this.settings.attendance_mode = null;
          break;

        case this.complianceText:
        case "Compliance":
          this.complianceAddedToDiagram = false;
          this.compliance = null;
          break;

        case this.outputText:
        case "Output":
          this.output = null;
          break;

        case this.feedbackText:
        case "Feedback":
          this.feedback = null;
          break;

        case this.notificationText:
        case "Notification":
          this.notification = null;
          break;

        case this.sectionText:
        case "Section":
          this.section = null;
          break;

        default:
          break;
      }
    },
    checkArray(arr) {
      return Array.isArray(arr);
    },
    checkNodeType(type) {
      return this.getNodeType.includes(type) ? true : false;
    },
    deleteComplianceSetting(index) {
      this.compliance.splice(index, 1);
      this.complianceSettings.splice(index, 1);
    },
    setJourneyData(journey) {
      this.journeyName = journey.name;
      this.journeyId = journey.id;
      this.journeyFlowCountsWithRemoteSignedInUsers =
        journey.journeyFlowCounts || 0;
    },
    setFlowData(flowData) {
      if (!flowData) return;

      this.hasSignedInUsers = flowData.hasSignedInUsersInRemoteAreas;
      this.journeyFlowId = flowData.id;
      this.description = flowData.description;
      this.name = flowData.name;
      // this.scene.nodes = flowData.diagram.nodes; //diagram nodes
      this.scene.nodes = flowData.diagram.nodes.map(node=>{
        return {
          ...node,
          type: this.translateNodeType(node.type)
        }
      })
    
    },
    setUserTypeData(userTypesObj) {
      this.userType = userTypesObj.userTypes?.filter(
        (userType) => userType.selected
      );
      this.userTypesOptions =
        userTypesObj.userTypes?.map((userType) => {
          if (userType.isUsedInAnthorFlow || !userType.permitted)
            userType.$isDisabled = true; //Disable unpermitted types & already used in another flow (same journey)
          return userType;
        }) || [];

      this.showUserTypeUnpermittedMessage =
        userTypesObj.showUnpermittedUserTypeMessage;
      this.registerationNotRequiredCount =
        userTypesObj.registerationNotRequiredCount;
    },
    setInputData(input) {
      const inputList = [
        "qr_code",
        "remote_sign_in",
        "rfid",
        "facial_recognition",
        "geofencing",
      ];
      Object.keys(input)?.forEach((key) => {
        if (inputList.includes(key)) this.inputTypes.push(input[key]);
      });
      this.inputSettings = cloneDeep(
        Object.keys(input).map((inputKey) => input[inputKey])
      );

      this.remoteSettings = cloneDeep(input.remote_sign_in?.chlidren?.location);
      this.input = this.inputTypes?.filter((inp) => !!inp.value);
      this.inputOnMount = cloneDeep(this.input);

      const remoteInput = this.input?.find(
        (inp) => inp.name === "remote_sign_in"
      );

      //#CL-9148 => disable "geofencing" option if selected and user(s) signed in on assigned flow
      const geofenceSelected = this.input?.find(
        (inp) => inp.name == "geofencing"
      );
      if (geofenceSelected?.$isDisabled)
        this.inputGeofenceSelectedAndDisabled = true;

      //Show remote warning only if remote is selected and disabled
      if (remoteInput && remoteInput.$isDisabled) {
        this.showInputNoteForSingleFlow = true;
        // if (this.journeyFlowCountsWithRemoteSignedInUsers == 1) {
        //   if (this.hasSignedInUsers) this.showInputNoteForMulitpleFlow = true;
        //   else this.showInputNoteForSingleFlow = true;
        // } else if (this.journeyFlowCountsWithRemoteSignedInUsers > 1)
        //   this.showInputNoteForMulitpleFlow = true;
      }

      //set diagram labels(values) to current language 
      this.scene.nodes?.forEach((node) => {
        if (node.type == this.inputText) {
          node.label = this.input.map((input) => input.label).join(",");
        }
      });
    },
    setChecksData(checks, entityTemperatureUnit) {
      const checksList = ["mask_check", "temperature_check"];
      const temperatureThreshold =
        checks.temperature_check.chlidren.temperature_threshold.value;

      Object.keys(checks).forEach((checksKey) => {
        if (checksList.includes(checksKey))
          this.checksOptions.push(checks[checksKey]);
      });

      this.check = this.checksOptions?.filter((check) => check.value);
      this.checksSetting = {
        temperature_threshold: {
          id: checks.temperature_check.chlidren.temperature_threshold.id,
          value:
            entityTemperatureUnit === "f"
              ? this.setToFehrenhite(temperatureThreshold)
              : temperatureThreshold,
          metadata:
            checks.temperature_check.chlidren.temperature_threshold.metadata,
        },
        temperature_check_type: {
          id: checks.temperature_check.chlidren.check_type.id,
          value: checks.temperature_check.chlidren.check_type.value,
          metadata: checks.temperature_check.chlidren.check_type.metadata,
        },
        company_temp_unit: entityTemperatureUnit,
      };
      
      //set diagram labels(values) to current language 
      this.scene.nodes?.forEach((node) => {
        if (node.type == this.checksText) {
          node.label =  this.check.map((check) => check.label).join(",");
        }
      });
    },
    setToFehrenhite(value) {
      let toFehrenhite = parseFloat(value) * (9 / 5) + 32;
      toFehrenhite = Math.round(toFehrenhite * 10) / 10;
      return toFehrenhite;
    },
    setToCelcius(value) {
      let toCelcius = ((parseFloat(value) - 32) * 5) / 9;
      toCelcius = Math.round(toCelcius * 10) / 10;
      return toCelcius;
    },
    getTimeType(type) {
      switch (type) {
        case "Mins":
          return this.userTypeSettingsOption[0];
        case "Hours":
          return this.userTypeSettingsOption[1];
        case "Days":
          return this.userTypeSettingsOption[2];
        default:
          return null;
      }
    },
    getTimeTypeById(id){
      switch (id) {
        case 1:
          return "Mins";
        case 2:
          return "Hours";
        case 3:
          return "Days";
        default:
          return null;
      }
    },
    setCompliancesData(compliances) {
      this.compliancesOptions = compliances;
      this.compliance = compliances?.filter(
        (compliance) => !!compliance.selected
      );
      //compliance settings
      this.compliance?.forEach((compliance) => {
        compliance.metadata?.notification?.forEach(notification=>{
          Object.assign(notification,{ typeOfTimeToSendBeforeVisit : this.getTimeType(notification.typeOfTimeToSendBeforeVisit),
          typeOfTimeToSendReminderVisit : this.getTimeType(notification.typeOfTimeToSendReminderVisit) })
        })
        const complianceObject = {};
        Object.assign(complianceObject, {
          id: compliance.id,
          name: compliance.name,
          type: compliance.type,
          setting: compliance.check_type,
          metadata: { notification: compliance.metadata?.notification },
        });
        let type = "";
        switch (compliance.type) {
          case "agreement":
            type = this.$t("common.agreement");
            break;
          case "questionnaire":
            type = this.$t("common.questionnaire");
            break;
          case "vaccine_document":
            type = this.$t("common.documentVaccinePcr");
        }
        if (this.onlineComplianceSettings[type])
          this.onlineComplianceSettings[type].push(complianceObject);
        else this.onlineComplianceSettings[type] = [complianceObject];
      });
    },
    setSectionData(section, sectionOptions) {
      this.sectionOptions = sectionOptions;
      this.section = sectionOptions.filter((section) => section.selected);
      this.sectionObject = section.section;
    },
    setHostData(host) {
      const hostSettings = host.host.chlidren;
      this.hostSettingObject = host.host;

      this.hostOptions = host.userTypes?.hosts?.map((host) => {
        if (host.is_disabled || !host.is_permitted) host.$isDisabled = true;
        return host;
      });
      this.settings.host = this.hostOptions?.filter((host) => host.is_selected);

      this.hostSetting = {
        notify_host: {
          id: hostSettings?.notify_host.id,
          value: hostSettings?.notify_host.value,
          metadata: hostSettings?.notify_host?.metadata,
        },
        allow_not_select_host: {
          id: hostSettings?.allow_not_select_host.id,
          value: hostSettings?.allow_not_select_host.value,
          metadata: hostSettings?.allow_not_select_host?.metadata,
        },
        isDisabledAllowNotSelectHost:
          host?.userTypes?.isDisabledAllowNotSelectHost,
      };
      this.hostNoteMessage = host.userTypes?.note;
      this.showHostsUnpermittedUserTypeMessage = this.hostOptions?.some(
        (type) => type.is_selected && !type.is_permitted
      );
    },
    async setAttendanceModeData(
      attendanceModesOptions,
      selectedAttendanceMode
    ) {
      this.attendanceModeObject = selectedAttendanceMode;
      // const journeySites = [];

      //Remove attendance node if touch mode is disabled
      if (!selectedAttendanceMode.value || !this.touch_mode)
        this.removeNodeAfterClearInput(
          this.settings.attendance_mode,
          this.attendanceModeText
        );

      if (this.touch_mode) {
        this.settings.attendance_mode = attendanceModesOptions?.find(
          (mode) => mode.id === selectedAttendanceMode?.value
        );

        const wondeIntegrations =
          await integtationService.getWondeIntegrations();
        this.attendanceModesOptions = attendanceModesOptions?.filter(
          (mode) => !mode.integration_id
        );

        const wondeAttendanceModes = attendanceModesOptions?.filter(
          (mode) => mode.integration_id
        );

        wondeAttendanceModes?.forEach((wondeMode) => {
          // Get integration_id from current attendance mode list(linked to wonde)
          const integrationId = wondeMode.integration_id;

          // Find that integrationId in the api list from '/directories/wonde' api
          const isAllowedIntegration = wondeIntegrations?.some(
            (mode) => mode.id == integrationId
          );

          // Check if wonde site exists/permitted in the current journey sites
          // isAllowedIntegration = wonde?.site?.some((wondeSite) => {
          //   return journeySites?.some((site) => site.id == wondeSite.id);
          // });

          //Add allowed wonde integrations to attendance modes options
          if (isAllowedIntegration) this.attendanceModesOptions.push(wondeMode);
        });

        //Check if current attendance mode is permitted ( current mode is permitted if it exists in the attendance mode options)
        const isCurrentModePermitted = this.attendanceModesOptions?.some(
          (mode) => mode.id == this.settings?.attendance_mode?.id
        );
        if (!isCurrentModePermitted && this.settings?.attendance_mode?.id)
          this.disableAttendanceMode = true;
      }

      // if (!this.settings.attendance_mode) {
      //   //remove attendance mode (late sign in - early sign out) from notificatio node
      //   const currentSelectedNotification =
      //     this.notification?.filter(
      //       (not) =>
      //         not.name != "early_signout_alert" &&
      //         not.name != "late_signin_alert"
      //     ) || [];

      //   if (currentSelectedNotification.length)
      //     this.editNode(this.notificationText, currentSelectedNotification);

      //   this.removeNodeAfterClearInput(
      //     this.settings.attendance_mode,
      //     this.attendanceModeText
      //   );
      // }
    },
    setOutputIndex(opt) {
      let index = 0;
      switch (opt.id) {
        case "7":
          index = 1;
          break;
        case "34":
          index = 2;
          break;
        case "14":
          index = 3;
          break;
        case "61":
          index = 4;
          break;
      }
      return index;
    },
    setOutputData(outputs) {
      this.outputs = Object.keys(outputs)?.map(
        (outputKey) => outputs[outputKey]
      );

      this.outputs = this.outputs?.map((opt) => {
        if (opt.name !== "save_data") {
          let obj = {};
          if (this.$route.name == "updateFlow") {
            //set door_relay (signIn ,checkIn) default loginmode values in case of edit flow on newly created entity
            //print_badge is handeled from backend as the print_badge will be selected by default.
            obj = {
              signIn:
                opt.name == "door_relay" && opt.metadata === null
                  ? true
                  : false,
              signOut: false,
              checkIn:
                opt.name == "door_relay" && opt.metadata === null
                  ? true
                  : false,
            };
          } else {
            //Set default values for login mode in case of "Add flow" route
            obj = {
              signIn: true,
              signOut: false,
              checkIn: true,
            };
          }
          Object.assign(opt, obj);
        }
        opt.index = this.setOutputIndex(opt);
        return opt;
      });

      //Assign 'login mode' for output (settings)
      //will only be accessed on "update flow" route since there will
      //be metadata if there's a selected output
      this.output = this.outputs?.filter((opt) => {
        let originalLoginMode = [];
        if (opt.name !== "save_data") {
          const loginMode = opt?.metadata && JSON.parse(opt.metadata);
          if (loginMode?.loginMode) {
            const isSignIn = loginMode.loginMode.includes(3);
            const isSignOut = loginMode.loginMode.includes(4);
            const isCheckIn = loginMode.loginMode.includes(1);

            if (isSignIn) {
              opt.signIn = true;
              originalLoginMode.push(3);
              opt.originalSignIn = true;
            }

            if (isSignOut) {
              opt.signOut = true;
              originalLoginMode.push(4);
            }

            if (isCheckIn) {
              opt.checkIn = true;
              originalLoginMode.push(1);
            }
          }
          opt.originalLoginMode = originalLoginMode;
        }
        return opt.value;
      });

      this.output = orderBy(this.output, "index");

      this.setWeigandSettings();

      this.scene.nodes?.forEach((node) => {
        if (node.type == this.outputText) {
          node.label = this.outputs.map((input) => input.label).join(",");
        }
      });
    },
    setWeigandSettings() {
      const optionsWeigand = [
        { id: "rfid", name: this.$t('journeyBuilder.flow.outputSettingsRFID') },
        { id: "face_recognition", name: this.$t('journeyBuilder.flow.outputSettingsFacialRecognition') },
      ];

      this.output?.forEach((output) => {
        if (output.id == "61" || output.name === "enable_weigand_output") {
          let weigand_output = [];

          if (!Array.isArray(output.chlidren.weigand_output_settings.value)) {
            weigand_output = compact(
              output.chlidren.weigand_output_settings.value.split(",")
            );

            Object.assign(output.chlidren.weigand_output_settings, {
              value: optionsWeigand?.map((opt) => {
                return { ...opt, value: weigand_output.includes(opt.id) };
              }),
            });
          }
        }
      });
    },
    updateNotificationSettings() {
      //Set reasons list
      let earlySignOutReasons = [];
      let lateSignInReasons = [];
      this.settings.attendance_mode?.reason?.forEach((reason) => {
        Object.assign(reason, { label: reason.name });

        if (reason.type === "sign_in") {
          if (reason.presented?.length)
            reason.presented?.forEach((presentedReason) => {
              lateSignInReasons.push({
                reason_id: reason.id,
                label: presentedReason,
                isPresented: true,
                id: presentedReason,
              });
            });
          else lateSignInReasons.push(reason);
        } else if (reason.type === "sign_out") {
          if (reason.presented?.length) {
            reason.presented?.forEach((presentedReason) => {
              earlySignOutReasons.push({
                reason_id: reason.id,
                label: presentedReason,
                isPresented: true,
                id: presentedReason,
              });
            });
          } else {
            earlySignOutReasons.push(reason);
          }
        }
      });

      this.notificationSettingModel.late_signin_alert.metadata = [];
      this.notificationSettingModel.late_signin_alert.lateSignInReasons =
        lateSignInReasons;

      this.notificationSettingModel.early_signout_alert.metadata = [];
      this.notificationSettingModel.early_signout_alert.earlySignOutReasons =
        earlySignOutReasons;
    },
    updateNotificationList() {
      //Get late_signin_alert & early_signout_alert setting
      const lateSignInSetting = cloneDeep(this.allNotificationSettings).find(
        (setting) => setting.name === "late_signin_alert"
      );
      const earlySignoutSetting = cloneDeep(this.allNotificationSettings).find(
        (setting) => setting.name === "early_signout_alert"
      );

      //Check if current/selected attendance mode has sign in/sign out reasons
      const hasSignInReason = this.settings.attendance_mode?.reason?.some(
        (reason) => reason.type === "sign_in"
      );
      const hasSignOutReason = this.settings.attendance_mode?.reason?.some(
        (reason) => reason.type === "sign_out"
      );

      //Check if late_signin_alert & early_signout_alert is already added to the list (to avoid duplicates)
      const isLateSignInExistToList = this.notifications.some(
        (opt) => opt.name === "late_signin_alert"
      );
      const isEarlySignOutExistToList = this.notifications.some(
        (opt) => opt.name === "early_signout_alert"
      );

      //Remove from dropdown list and current notification selection(if selected)
      if (hasSignInReason)
        !isLateSignInExistToList && this.notifications.push(lateSignInSetting);
      else {
        this.notification = this.notification?.filter(
          (opt) => opt.name != "late_signin_alert"
        );
        this.notifications = this.notifications.filter(
          (opt) => opt.name != "late_signin_alert"
        );
      }

      if (hasSignOutReason)
        !isEarlySignOutExistToList &&
          this.notifications.push(earlySignoutSetting);
      else {
        this.notification = this.notification?.filter(
          (opt) => opt.name != "early_signout_alert"
        );
        this.notifications = this.notifications.filter(
          (opt) => opt.name != "early_signout_alert"
        );
      }
    },
    setNotificationData(notifications) {
      const notificationList = [
        "compliance_alert",
        "mask_alert",
        "temperature_alert",
      ];

      Object.keys(notifications)?.forEach((key) => {
        if (notificationList.includes(key))
          this.notifications.push(notifications[key]);
      });

      this.updateNotificationList();

      this.notification = this.notifications?.filter((opt) => opt.value);

      //Set selected reasons
      let lateSignInSelectedReasons =
        JSON.parse(notifications.late_signin_alert.metadata)?.reason || [];
      let lateSignInMetadata = [];

      lateSignInSelectedReasons?.forEach((reason) => {
        let tempReason = {};
        if (reason.presented?.length) {
          reason.presented.forEach((presentedReason) => {
            tempReason = {
              reason_id: reason.id,
              label: presentedReason,
              isPresented: true,
              id: presentedReason,
            };
            lateSignInMetadata.push(tempReason);
          });
        } else lateSignInMetadata.push(reason);
      });

      let earlySignOutSelectedReasons =
        JSON.parse(notifications.early_signout_alert.metadata)?.reason || [];
      let earlySignOutMetadata = [];

      earlySignOutSelectedReasons?.forEach((reason) => {
        let tempReason = {};
        if (reason.presented?.length) {
          reason.presented.forEach((presentedReason) => {
            tempReason = {
              reason_id: reason.id,
              label: presentedReason,
              isPresented: true,
              id: presentedReason,
            };
            earlySignOutMetadata.push(tempReason);
          });
        } else earlySignOutMetadata.push(reason);
      });
      //Set reasons list
      let earlySignOutReasons = [];
      let lateSignInReasons = [];
      this.settings.attendance_mode?.reason?.forEach((reason) => {
        Object.assign(reason, { label: reason.name });

        if (reason.type === "sign_in") {
          if (reason.presented?.length)
            reason.presented?.forEach((presentedReason) => {
              lateSignInReasons.push({
                reason_id: reason.id,
                label: presentedReason,
                isPresented: true,
                id: presentedReason,
              });
            });
          else lateSignInReasons.push(reason);
        } else if (reason.type === "sign_out") {
          if (reason.presented?.length) {
            reason.presented?.forEach((presentedReason) => {
              earlySignOutReasons.push({
                reason_id: reason.id,
                label: presentedReason,
                isPresented: true,
                id: presentedReason,
              });
            });
          } else {
            earlySignOutReasons.push(reason);
          }
        }
      });

      this.notificationSetting = [
        notifications.notification.chlidren.send_via_email,
        notifications.notification.chlidren.send_to_email,
      ];

      this.notificationSettingModel = {
        send_to_email: {
          id: notifications.notification.chlidren.send_to_email.id,
          value: notifications.notification.chlidren.send_to_email.value || "",
          metadata: notifications.notification.chlidren.send_to_email.metadata,
          type: "string",
        },
        send_via_email: {
          id: notifications.notification.chlidren.send_via_email.id,
          value: notifications.notification.chlidren.send_via_email.value,
          metadata: notifications.notification.chlidren.send_via_email.metadata,
          type: "boolean",
        },
        late_signin_alert: {
          id: notifications.late_signin_alert.id,
          value: notifications.early_signout_alert.value,
          metadata: lateSignInMetadata,
          lateSignInReasons,
          type: "metadata",
        },
        early_signout_alert: {
          id: notifications.early_signout_alert.id,
          value: notifications.early_signout_alert.value,
          metadata: earlySignOutMetadata,
          earlySignOutReasons,
          type: "metadata",
        },
      };

      this.scene.nodes?.forEach((node) => {
        if (node.type == this.notificationText) {
          node.label = this.notifications.map((input) => input.label).join(",");
        }
      });
    },
    setFeedbackData(feedback) {
      const feedbackList = [
        "audio_feedback",
        "light_feedback",
        "temperature_feedback",
      ];
      Object.keys(feedback)?.forEach((key) => {
        if (feedbackList.includes(key)) this.feedbacks.push(feedback[key]);
      });

      this.feedback = this.feedbacks?.filter((opt) => opt.value);
      this.feedbackSetting = Object.keys(
        feedback.message_feedback?.chlidren //Add granted_message & denied_message setting
      )?.map((key) => feedback.message_feedback?.chlidren[key]);

      this.feedbackSetting.push(feedback.good_bye_message); //Add good_bye_message setting
      this.feedbackSetting.push(feedback.display_name_feedback); //Add first name setting

      this.scene.nodes?.forEach((node) => {
        if (node.type == this.feedbackText) {
          node.label = this.feedback.map((input) => input.label).join(",");
        }
      });
    },
    changeAttendanceModeVal() {
      this.updateNotificationList();
      this.updateNotificationSettings();
      this.checkNodeType(this.attendanceModeText)
        ? this.editNode(this.attendanceModeText, this.settings.attendance_mode)
        : this.addNode(
            this.attendanceModeText,
            this.settings.attendance_mode,
            720,
            100
          );
    },
  },
  async beforeMount() {
    try {
      const apiID = this.$route.params.id;
      this.currentRoute = this.$route.name;

      let response = null;

      if (this.currentRoute == "updateFlow")
        response = await journeyService.flowInfo(apiID);
      else response = await journeyService.journeyNewFlow(apiID);

      const { data } = response;
      const {
        flow,
        userTypes,
        compliances,
        settings,
        touchMode,
        showUnpermittedUserTypeMessage,
        registerationNotRequiredCount,
        attendanceModes,
        journey,
        entityTemperature,
        sections: sectionOptions,
      } = data;
      const {
        attendance_mode,
        checks,
        feedback,
        host,
        input,
        notifications,
        outputs,
        section,
      } = settings;

      const userTypesObj = {
        userTypes: userTypes,
        showUnpermittedUserTypeMessage,
        registerationNotRequiredCount,
      };

      this.companyTemp = entityTemperature.value.toLowerCase();
      this.touch_mode = touchMode.value;

      //For submitted data
      this.allNotificationSettings = cloneDeep(
        Object.keys(notifications)?.map((key) => notifications[key])
      );

      Object.keys(feedback)?.forEach((key) => {
        if (feedback[key].id != "107" && feedback[key].id != "112")
          this.allFeedbackSettings.push(feedback[key]);
      });

      this.setJourneyData(journey);
      this.setFlowData(flow);

      this.setUserTypeData(userTypesObj);
      this.setInputData(input);
      this.setChecksData(checks, this.companyTemp);
      this.setCompliancesData(compliances);
      this.setSectionData(section, sectionOptions);
      this.setHostData(host);
      this.setAttendanceModeData(attendanceModes, attendance_mode);
      this.checkUserTypesWithModes();
      this.setOutputData(outputs);
      this.setNotificationData(notifications);
      this.setFeedbackData(feedback);

      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  },
  mounted() {
    localStorage.removeItem("firstSelectedRegisterType");
  },
};
</script>
<style lang="scss">
.mail {
  color: #2680eb;
  font-weight: 700;
  text-decoration: underline;
}
.disabled-tags {
  opacity: 0.6 !important;
  pointer-events: none;
}
div#hostSettings {
  div#hostSettings___BV_modal_content_:lang(ar){
    transform: translate(50%, 30%);
  }
  div#hostSettings___BV_modal_content_ {
    position: absolute;
    inset-inline-start: 50%;
    top: 50%;
    transform: translate(-50%, 30%);
    width: 491px !important;
    box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
    border-radius: 26px;
    div#hostSettings___BV_modal_body_ {
      padding-top: 32px !important;
      padding-inline-end: 33px !important;
      padding-bottom: 38px !important;
      padding-inline-start: 38px !important;
      .modal-header-group {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 38px;
        .host-modal-header-title {
          margin-inline-end: 139px;

          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          color: #000000;
        }
      }
      .custom-checkbox
        .custom-control-input:disabled:checked
        ~ .custom-control-label::before {
        border: transparent !important;
      }
      label.custom-control-label {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.25px;
        padding-inline-start: 15px;
      }
    }
  }
}

.allow_not_select_host {
  width: 373px;

  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #939393;
  opacity: 0.8;
  margin-bottom: 37px;
}

.hostSettingsCheckbox {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #666666;
  margin-bottom: 20px;
}

.disabled-host-checkbox-with-value .custom-control-label::before {
  background-color: #666666 !important;
  opacity: 0.6 !important;
}

.disabled-label-color {
  color: #666666 !important;
  opacity: 0.6 !important;
}

.saveBtn {
  width: 415px;
  height: 44px;
  background: #103f5e;
  border-radius: 22px;

  font-weight: 700;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.87);
}

.bs-tooltip-bottom .arrow::before {
  border-color: #ffffff !important;
}
p.output-spacing {
  margin-top: 30px;
  margin-bottom: 30px;
  font-weight: 700;
}
td.bold-cell {
  font-weight: 900;
}
.journey-builder {
  background-color: #fff;
  .journey-wrapper {
    font-size: 1.1rem;
  }
  .compliance-checks {
    border: 1px solid #ccc;
  }
  .settings-icon {
    background: transparent;
    border: none;
    padding: unset;
    cursor: pointer;
    font-size: 1.2rem;
    transition: 0.5s;
    color: #818794;
    outline: none;
    &:hover {
      color: #1971c2;
    }
    &:disabled:hover {
      color: #818794;
    }
  }
  .add-icon {
    font-size: 1.8rem;
    color: #103f5e;
    transition: 0.5s;
    &:hover {
      color: #1971c2;
    }
  }
  .dropdown-divider {
    border-top-color: #dddbda;
    margin: 1% 0;
  }
  .journey-select-wrapper {
    width: 70%;
  }
  .journey-inputs-wrapper {
    width: 400px;
    margin-inline-end: 2%;
  }
  // diagram style
  #flowchart {
    position: relative;
    bottom: -30px;
    // font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0;
    .cancel-btn{
      margin-inline-start: 1.5rem;
    }
    .flowchart-wrapper {
      background-color: #f8f8fb;
      height: 86.5% !important;
    }
    .flowchart-node {
      box-shadow: 0 0 0 2px #dddbda;
      width: 150px !important;
      height: 100px !important;
    }
    .node-type {
      background-color: #fafaf9;
      color: #000;
      border-bottom: 1px solid #dddbda;
    }
    .node-label {
      padding: 0px 10px;
      color: #000;
      text-align: start;
      font-size: 0.7rem;
      font-weight: bold;
      border-color: black;
      margin-top: 5px;
      max-height: 50px;
      overflow: hidden;
    }
    .node-port {
      display: none;
    }
    .node-delete {
      line-height: 15px;
      width: 15px;
      height: 15px;
      color: #103f5e;
      background: #fff;
      border: 1px solid #103f5e;
      &:hover {
        color: #fff;
        background: #103f5e;
      }
    }
  }
}
</style>